import { useEffect, useState } from 'react'

import { API } from '@/api'
import { Volume } from '@/api/type-server'

import { filterValidVolumes } from '../utils'

export function useVolumeData(machineDomains?: number[]) {
  const [volumes, setVolumes] = useState<Volume[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!machineDomains || machineDomains.length === 0) {
      setVolumes([])
      return
    }

    setLoading(true)
    API.getVolumes()
      .then((response) => {
        if (response?.code === 0) {
          const filteredVolumes = filterValidVolumes(response.volumes || [], machineDomains)
          setVolumes(filteredVolumes)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [machineDomains])

  return { volumes, loading }
}
